export const data = [
    {id:1,
    name:"Uzmobile",
    img:"https://halberdbastion.com/sites/default/files/styles/medium/public/2017-10/UzMobile-logo.png?itok=hd3_ETvs"
    },
    {id:2,
    name:"Beeline",
    img:"https://upload.wikimedia.org/wikipedia/commons/7/7a/BeeLine_logo.png"
    },
    {id:3,
    name:"Ucell",
    img:"https://logobank.uz:8005/media/logos_png/Ucell-01.png"
    },
    {id:4,
    name:"Mobiuz",
    img:"https://logobank.uz:8005/media/logos_png/Mobiuz-01.png"
    },
    {id:5,
    name:"Perfectum",
    img:"https://logobank.uz:8005/media/logos_png/Perfectum-01.png"
    },
    {id:6,
    name:"TELE2",
    img:"https://upload.wikimedia.org/wikipedia/commons/thumb/6/69/Tele2_logo.svg/1280px-Tele2_logo.svg.png"
    },
    {id:7,
    name:"Megafon",
    img:"https://download.logo.wine/logo/MegaFon/MegaFon-Logo.wine.png"
    },
    {id:8,
    name:"Altel",
    img:"https://www.pay4.uz/wp-content/uploads/2019/12/altel-450x450.png"
    },
    {id:9,
    name:"Kcell",
    img:"https://halberdbastion.com/sites/default/files/styles/medium/public/2017-08/Kcell-Kazakhstan_Logo.png?itok=6CffZjXK"
    },
    {id:10,
    name:"Moldcell",
    img:"https://upload.wikimedia.org/wikipedia/commons/b/be/Moldcell_logo_new.png"
    },
    {id:11,
    name:"Yota",
    img:"https://logos-download.com/wp-content/uploads/2016/05/Yota_logo_logotype.png"
    },
]

export const communalData = [
    {
        id:1,
        name:"Gas",
        img:"https://pngimage.net/wp-content/uploads/2018/06/gas-flame-png-2.png"
    },
    {
        id:2,
        name:"Electricity",
        img:"https://www.downloadclipart.net/large/electric-bulb-download-png-image.png"
    },
    {
        id:3,
        name:"Gas",
        img:"https://pngimage.net/wp-content/uploads/2018/06/gas-flame-png-2.png"
    },
    {
        id:4,
        name:"Electricity",
        img:"https://www.downloadclipart.net/large/electric-bulb-download-png-image.png"
    },
    {
        id:5,
        name:"Gas",
        img:"https://pngimage.net/wp-content/uploads/2018/06/gas-flame-png-2.png"
    },
    {
        id:6,
        name:"Electricity",
        img:"https://www.downloadclipart.net/large/electric-bulb-download-png-image.png"
    },
    {
        id:7,
        name:"Gas",
        img:"https://pngimage.net/wp-content/uploads/2018/06/gas-flame-png-2.png"
    },
    {
        id:8,
        name:"Electricity",
        img:"https://www.downloadclipart.net/large/electric-bulb-download-png-image.png"
    },
    {
        id:9,
        name:"Gas",
        img:"https://pngimage.net/wp-content/uploads/2018/06/gas-flame-png-2.png"
    },
    {
        id:10,
        name:"Electricity",
        img:"https://www.downloadclipart.net/large/electric-bulb-download-png-image.png"
    },
    {
        id:11,
        name:"Gas",
        img:"https://pngimage.net/wp-content/uploads/2018/06/gas-flame-png-2.png"
    },
    {
        id:12,
        name:"Electricity",
        img:"https://www.downloadclipart.net/large/electric-bulb-download-png-image.png"
    },
    {
        id:13,
        name:"Gas",
        img:"https://pngimage.net/wp-content/uploads/2018/06/gas-flame-png-2.png"
    },
    {
        id:14,
        name:"Electricity",
        img:"https://www.downloadclipart.net/large/electric-bulb-download-png-image.png"
    },
    
]